import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import contact from "../images/contact.png";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { IoNavigate } from "react-icons/io5";

function ContactHome() {
  const navto = useNavigate();
  const contactpage = () => {
    navto("/contact");
  };
  // onscrollanimation start
  const anime1 = {
    visible: {
      opacity: 1,
      x: 0,
      transition: { ease: "easeInOut", duration: 0.9 },
    },
    hidden: { opacity: 0, x: -100 },
  };
  const anime2 = {
    visible: {
      opacity: 1,
      x: 0,
      transition: { ease: "easeInOut", duration: 0.9 },
    },
    hidden: { opacity: 0, x: 100 },
  };

  const control = useAnimation();
  const [ref, inView] = useInView();
  useEffect(() => {
    if (inView) {
      control.start("visible");
    } else {
      control.start("hidden");
    }
  }, [control, inView]);
  // onscrollanimation end
  return (
    <>
      <motion.div className="col-lg-6 col-md-12 col-sm-12"  ref={ref}
            variants={anime1}
            initial="hidden"
            animate={control}>
        <div className="inner-sec">
          <h2 className="sec-head">Contact</h2>
          <p className="sec-para">
            If you are seeking a specialist to complete your task, you have come
            to the right place. I am always interested in hearing about new
            projects, new ideas, or opportunities to be a part of your
            aspirations. Please feel free to contact me if you have any
            questions.
          </p>
          <motion.button
            className="sec-btn btn "
            initial={{ opacity: 0.6 }}
            whileHover={{
              scale: 1.1,
              transition: { duration: 1 },
            }}
            whileTap={{ scale: 0.9 }}
            whileInView={{ opacity: 1 }}
            onClick={contactpage}
          >
            Know More <span className="ms-2"><IoNavigate /></span>
          </motion.button>
        </div>
      </motion.div>
      <motion.div className="col-lg-6 col-md-12 col-sm-12 text-center"  ref={ref}
            variants={anime2}
            initial="hidden"
            animate={control}>
        <img src={contact} alt="contact" className="sec-img-w" />
      </motion.div>
    </>
  );
}

export default ContactHome;
